// extracted by mini-css-extract-plugin
export default {"header":"Header_header__cnNRJ","main-image":"Header_main-image__-20Eg"};